var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11596 0C0.819997 2.80343e-05 0.536166 0.111423 0.326889 0.309685C0.117613 0.507947 2.95917e-05 0.77684 0 1.05722V43.3462C2.95917e-05 43.6266 0.117613 43.8955 0.326889 44.0937C0.536166 44.292 0.819997 44.4034 1.11596 44.4034H45.7543C46.0503 44.4034 46.3341 44.292 46.5434 44.0937C46.7527 43.8955 46.8702 43.6266 46.8703 43.3462V1.05722C46.8702 0.77684 46.7527 0.507947 46.5434 0.309685C46.3341 0.111423 46.0503 2.80343e-05 45.7543 0H1.11596ZM2.23192 2.11445H44.6384V42.289H2.23192V2.11445ZM12.2755 20.0873V23.7297H17.8553V40.1745H22.3192V23.7297H27.899V20.0873H12.2755ZM36.4823 20.0976C33.0065 20.0845 29.0345 21.0823 29.0345 25.7162C29.0345 31.774 37.6505 31.7755 37.6505 34.5085C37.6505 34.7675 37.7665 36.6498 34.7255 36.6498C31.6845 36.6498 29.1501 34.8388 29.1501 34.8388V39.235C29.1501 39.235 42.4086 43.2976 42.4086 34.1368C42.4075 28.1899 33.712 28.4873 33.712 25.5324C33.712 24.3874 34.5706 23.3167 36.9487 23.3168C39.3268 23.3168 41.4322 24.6465 41.4322 24.6465L41.5891 20.7294C41.5891 20.7294 39.1857 20.1078 36.4823 20.0976Z",
    fill: "#4B4E59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.8703,
    height: 44.4034,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.fe22bfa8675a8b555bc3295f6c142e84.svg";
export { ForwardRef as ReactComponent };